<template>
  <div>
    <Navbar/>
    <h4>Dosis</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idDosis" class="form-label">IdDosis</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDosis" name="idDosis" v-model="datoDosis.idDosis" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoDosis.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarDosis" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditDosis" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdInterMed</th>
          <th scope="col">IdInterconsulta</th>
          <th scope="col">IdElemento</th>
          <th scope="col">IdFrecuencia</th>
          <th scope="col">IdDosis</th>
          <th scope="col">Duracion</th>
          <th scope="col">Indicacion</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">DosisNombre</th>
          <th scope="col">InterconsultaFechaReg</th>
          <th scope="col">FrecuenciaNombre</th>
          <th scope="col">ElementoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="intermed in datosPaginados" :key="intermed.idInterMed">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(intermed.idInterMed)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(intermed.idInterMed)" title="Editar">edit_square</i></td>
          <td>{{intermed.idInterMed}}</td>
          <td>{{intermed.idInterconsulta}}</td>
          <td>{{intermed.idElemento}}</td>
          <td>{{intermed.idFrecuencia}}</td>
          <td>{{intermed.idDosis}}</td>
          <td>{{intermed.duracion}}</td>
          <td>{{intermed.indicacion}}</td>
          <td>{{intermed.observacion}}</td>
          <td>{{intermed.estado}}</td>
          <td>{{intermed.dosisNombre}}</td>
          <td>{{getFormattedDate(intermed.interconsultaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{intermed.frecuenciaNombre}}</td>
          <td>{{intermed.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteDosis(intermed.idInterMed)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idInterMed" class="form-label">IdInterMed</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterMed" name="idInterMed" v-model="datoInterMed.idInterMed" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label"> Interconsulta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterMed.idInterconsulta">
                      <option v-for="interconsulta in interconsultas" :value="interconsulta.idInterconsulta" :key="interconsulta.idInterconsulta">
                        {{ interconsulta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoInterMed.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idFrecuencia" class="form-label"> Frecuencia</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFrecuencia" name="idFrecuencia" v-model="datoInterMed.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idDosis" class="form-label">IdDosis</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDosis" name="idDosis" v-model="datoInterMed.idDosis" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="duracion" class="form-label">Duracion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="duracion" name="duracion" v-model="datoInterMed.duracion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="indicacion" class="form-label">Indicacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="indicacion" name="indicacion" v-model="datoInterMed.indicacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoInterMed.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterMed" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterMed" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      dosiss : [],
      datoDosis : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idDosis: '',
// Variables master
// Variables details
      intermeds : [],
      datoInterMed : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      interconsultas : [],
      elementos : [],
      frecuencias : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idDosis = this.$route.params.p_iddosis
    this.abrirEditar(this.p_idDosis)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoDosis, requiredFields, requiredFieldsText);
    },
    async guardarDosis(){
      if(this.validarForm() === 1){
        try {
          await api.post('/dosiss', this.datoDosis)
          swal("Correcto!", "Dosis creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDosis(){
      if(this.validarForm() === 1){
        try {
          await api.post('/dosiss', this.datoDosis)
          swal("Correcto!", "Dosis creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoDosis={}
      this.titulo   = 'Crear Dosis'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idDosis){
      this.modalWindow = true
      if(idDosis != null){    
           api.get('/vwdosiss/'+idDosis).then(resp=>{
          this.datoDosis = resp.data;
           });
      }
      this.titulo   = 'Editar Dosis'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarDosis(){
      this.$router.push('/Dosis')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.intermeds.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwintermeds/nombre/'+this.nombreBusqueda).then(response=>{
          this.intermeds=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.intermeds.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwintermeds').then(response=>{
      this.intermeds=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.intermeds.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoDosis, requiredFields, requiredFieldsText);
    },
    async guardarInterMed(){
      if(this.validarForm() === 1){
        try {
          this.datoInterMed.idDosis = this.datoDosis.idDosis;
          await api.post('/intermeds', this.datoInterMed)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "InterMed creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterMed(){
      if(this.validarForm() === 1){
        try {
          await api.post('/intermeds', this.datoInterMed)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "InterMed creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoInterMed={}
      this.titulo   = 'Crear Dosis'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idInterMed){
      this.modalWindow = true
      if(idInterMed != null){    
           api.get('/vwintermeds/'+idInterMed).then(resp=>{
          this.datoInterMed = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Dosis'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idInterMed){
      this.modalWindow = true
      if(idInterMed != null){
        this.$router.push('/intermedmd/'+idInterMed)
      }
    },
    async deleteInterMed (idInterMed) {
      try{
        await api.delete('/intermeds/'+idInterMed)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchInterconsultas() {
      fetch('http://localhost:8080/api/v1/interconsultas')
        .then(response => response.json())
        .then(data => {
          this.interconsultas = data;
        })
        .catch(error => {
          console.error('Error fetching interconsultas:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchFrecuencias() {
      fetch('http://localhost:8080/api/v1/frecuencias')
        .then(response => response.json())
        .then(data => {
          this.frecuencias = data;
        })
        .catch(error => {
          console.error('Error fetching frecuencias:', error);
        });
    },
    fetchDosiss() {
      fetch('http://localhost:8080/api/v1/dosiss')
        .then(response => response.json())
        .then(data => {
          this.dosiss = data;
        })
        .catch(error => {
          console.error('Error fetching dosiss:', error);
        });
    },
  },
}
</script>
